import { render, staticRenderFns } from "./geneStatistics.vue?vue&type=template&id=3a22b1a0&scoped=true"
import script from "./geneStatistics.vue?vue&type=script&lang=js"
export * from "./geneStatistics.vue?vue&type=script&lang=js"
import style0 from "./geneStatistics.vue?vue&type=style&index=0&id=3a22b1a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22b1a0",
  null
  
)

export default component.exports